import React, { useEffect, memo } from "react";
import { AuthManager } from "./Auth";
import { Typography } from "@material-ui/core";
import LoginLayout from "./LoginLayout";

interface ILoginCallbackProps {
  authProvider: AuthManager;
}

const LoginCallback = (props: ILoginCallbackProps) => {
  useEffect(() => {
    props.authProvider.handleAuthentication();
  }, [props.authProvider]);

  return (
    <LoginLayout>
      <Typography variant="body1">Please wait...</Typography>
    </LoginLayout>
  );
};

export default memo(LoginCallback);
